define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/profiles/permissionGridRowView.tmpl");
    var Loader = require("ui/loader/Loader");
    var PlusCompositeView = require("ui/plus-composite-view/PlusCompositeView");
    var LocaleResolver = require('i18n/localeResolver');

    var ToggleButton = require("ui/toggle-button/toggleButton");

    var PermissionsGridRowView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        PermissionsGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "permission-row",
            template: template,
            ui: {
                permission: ".permission .content",
                enabled: ".enabled"
            },
            uiComponents: {
                enabled: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.enabled",
                        checked: "view._getEnabledState",
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_onEnabledChange"
                    }
                }
            },
            events: {
            },

            customTemplateHelpers: function () {
                var id = this.model.getId();

                // Check if tooltip exist
                var translatedPackageTooltipKey = "LEUserManagement.profile.permission." + id + ".tooltip";
                var isPackageTranslated = LE.translator.hasTranslationKey(LocaleResolver.getDefaultLocale(), translatedPackageTooltipKey);
                var tooltip = isPackageTranslated ? LE.translator.translate(translatedPackageTooltipKey) : "";

                return {
                    permissionText: LE.translator.translate("LEUserManagement.profile.permission." + id),
                    permissionTooltip: tooltip
                };
            },

            initialize: function (options) {
                LEUserManagement.logger.debug("initialize", "PermissionsGridRowView:initialize");
                this.loaders = [];
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.PROFILE_EDIT);
                this._bindEvents();
            },

            onRender: function () {
                LEUserManagement.logger.debug("onRender", "PermissionsGridRowView:onRender");
            },
            onClose: function () {
                LEUserManagement.logger.debug("onClose", "PermissionsGridRowView:onClose");
            },
            _onEnabledChange: function (componentId, eventName, value) {
                this.model.setIsEnabled(value);
                this.channel.trigger("profile:change:permissions");
            },
            _getEnabledState: function() {
                return this.model.isEnabled();
            },
            _bindEvents: function (checked) {
                LEUserManagement.logger.debug("_bindEvents", "PermissionsGridRowView:_bindEvents");
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return PermissionsGridRowView;
});
